export default __webpack_public_path__ + "static/artifakt-legend-light-61002b6ed4833ae1c6fa8324028984d7.woff2";